module.exports = __webpack_public_path__ + "img/12.4216d253.jpg";